module.exports = __webpack_public_path__ + "static/media/browser.49259b89.svg";